export default {
	shortstay: [
		"Day program",
		"Dedicated respite room(s)",
		"Emergency respite",
		"Non-ACAT respite accepted",
		"Non-weight bearing",
		"Planned respite",
		"Respite in secure dementia care"
	]
};
